<template>
  <v-container fluid style="position: absolute; top: 5%; pointer-events: none; z-index:700; text-align:center">
    <v-flex d-inline-flex class="shrink">
      <v-alert
        color="success"
        :value="updateAvailable"
        dismissible
        transition="scale-transition"
        tag="div"
        class="mx-auto my-2 text-center rounded-xl"
        style="pointer-events: all; z-index:70"
      >
        <template v-slot:append>
          <v-icon size="30" class="mr-4" color="yellow">
            mdi-cellphone-arrow-down
          </v-icon>
          Nueva versión disponible
          <v-btn class="mx-2" color="yellow" text @click="refreshApp">
            Actualizar
          </v-btn>
        </template>
      </v-alert>
    </v-flex>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      updateAvailable: false,
      registration: null,
    }
  },
  created() {
    document.addEventListener('swUpdated', this.onSwUpdated, { once: true })
  },
  beforeDestroy() {
    document.removeEventListener('swUpdated', this.onSwUpdated)
  },

  methods: {
    onSwUpdated(event) {
      this.registration = event.detail
      this.updateAvailable = true
    },

    refreshApp() {
      this.updateAvailable = false
      window.location.reload()
    },
  },
}
</script>

<style scoped>
.v-alert {
    backdrop-filter: blur(18px) saturate(160%) !important;
    -webkit-backdrop-filter: blur(18px) saturate(160%) !important;
    border-radius: 14px !important;
}

/* ── Light mode — more transparent ── */
.theme--light .v-alert.error   { background: rgba(255, 61,  61,  0.90) !important; }
.theme--light .v-alert.warning { background: rgba(251, 140,  0,  0.90) !important; }
.theme--light .v-alert.success { background: rgba(30,  200, 130, 0.90) !important; }
.theme--light .v-alert.info    { background: rgba(33,  150, 243, 0.90) !important; }

/* ── Dark mode — more opaque ── */
.theme--dark .v-alert.error   { background: rgba(255, 61,  61,  0.55) !important; }
.theme--dark .v-alert.warning { background: rgba(251, 140,  0,  0.55) !important; }
.theme--dark .v-alert.success { background: rgba(30,  200, 130, 0.55) !important; }
.theme--dark .v-alert.info    { background: rgba(33,  150, 243, 0.55) !important; }

/* Dark mode border — subtler white highlight */
.theme--dark .v-alert {
    border-color: rgba(255, 255, 255, 0.15) !important;
    box-shadow:
        0 8px 32px rgba(0, 0, 0, 0.35),
        0 2px 8px rgba(0, 0, 0, 0.25),
        inset 0 1px 0 rgba(255, 255, 255, 0.08) !important;
}
</style>